export const STAFF = '/staff/' as const
export const STAFF_INFO = `${STAFF}info/` as const
export const STAFF_ALL = `${STAFF}all` as const
export const STAFF_ALL_FILTERED = `${STAFF_ALL}/filtered` as const
export const STAFF_PERSONAL_INFO = `${STAFF}personal_info` as const
export const STAFF_FULL_INFO = `${STAFF}full_info` as const
export const STAFF_HR_INFO = `${STAFF}hr_info` as const
export const STAFF_DEPARTMENT_POSITION = `${STAFF}department-position` as const
export const STAFF_USERNAME = `${STAFF}username/` as const
export const STAFF_PROOF_OF_WORK_PDF = `${STAFF}proof-of-work-pdf` as const
export const PUBLIC_STAFF_REF = '/public/proof_of_work' as const
